import { PumpkinMark } from "./Logo";

const links = [
  { id: "#lore", label: "Lore" },
  { id: "#tokenomics", label: "Tokenomics" },
  { id: "#roadmap", label: "Roadmap" },
  { id: "#community", label: "Community" },
];

export default function Footer({ onNavigate }) {
  return (
    <footer
      data-testid="footer-container"
      className="relative overflow-hidden border-t border-purple-900/40 bg-[#050408] px-6 pb-12 pt-20 sm:px-12"
    >
      <p
        aria-hidden="true"
        className="text-outline pointer-events-none select-none whitespace-nowrap text-center font-cinzel text-[12.5vw] font-black leading-none tracking-tight"
      >
        FOMOWEEN
      </p>

      <div className="relative mx-auto mt-4 flex max-w-7xl flex-col items-center justify-between gap-8 border-t border-orange-500/10 pt-10 md:flex-row">
        <div data-testid="footer-logo" className="flex items-center gap-3">
          <PumpkinMark size={34} />
          <span className="font-cinzel text-base font-black tracking-wide text-zinc-100">
            FOMO<span className="text-pumpkin">WEEN</span>
          </span>
        </div>

        <nav className="flex flex-wrap items-center justify-center gap-6">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`footer-link-${l.label.toLowerCase()}`}
              onClick={() => onNavigate(l.id)}
              className="font-mono text-[11px] font-semibold uppercase tracking-[0.25em] text-zinc-500 transition-colors hover:text-pumpkin"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <a
          data-testid="footer-link-x"
          href="https://x.com/FOMOWEENCOIN"
          target="_blank"
          rel="noreferrer"
          className="font-mono text-[11px] font-semibold uppercase tracking-[0.25em] text-zinc-500 transition-colors hover:text-pumpkin"
        >
          @FOMOWEENCOIN
        </a>
      </div>

      <p
        data-testid="footer-disclaimer"
        className="relative mx-auto mt-10 max-w-3xl text-center text-xs leading-relaxed text-zinc-600"
      >
        $FOMOWEEN is a seasonal meme coin created for entertainment purposes
        and degen Halloween fun. Cryptocurrency trading carries high market
        volatility — don't invest what you aren't prepared to turn into a
        ghost.
      </p>
      <p className="relative mt-6 text-center font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-700">
        © 2026 FOMOWEEN. All ghosts reserved.
      </p>
    </footer>
  );
}
